import { WarekiType } from "../defines";
import * as wijmo from 'wijmo/wijmo';
import $ from 'jquery'
import { MasterDispName, MasterKbn, SummaryReplaceString, SummaryStyleClass } from "../../core/constants/constant";
import { WindowOption, WindowUtil } from "../../support/component/drillDown/windowUtil";

/**
 * 連想制御可能なデータを示すインターフェース
 */
export interface RensouData {
    code: string;
    masterKbn: number;
    displayValue: string;
    subNameValue: string;
    rensou: string;
    simpleFlag: boolean;
    detailFlag: boolean;
    displayFlag: boolean;
}

/**
 * 固定摘要登録ドリルダウン用インターフェース
 */
export interface TekiyoEntory {
    tekiChar: string,
    rensoKmkCode1: number,
    rensoKmkCode2: number
}

/**
 * 連想制御可能な定型Noデータを示すインターフェース
 */
export interface FxNoRensouData extends RensouData {
    ColorChange: number;
}

/**
 * 消費税率ウィンドウのインターフェース
 */
export interface TaxRateRensouData extends RensouData {
    taxRateKbn: number;
    isPre: boolean;
}

export class FxNoRensou implements RensouData {
    public get code(): string { return this.No.toString(); }
    public get masterKbn(): number { return null!; }
    public get displayValue(): string { return this.Name; }
    public get subNameValue(): string { return null!; }
    public get rensou(): string { return this.RenChar; }
    public get simpleFlag(): boolean { return true; }
    public get detailFlag(): boolean { return true; }
    public get displayFlag(): boolean { return true; }

    /** 定型NO */
    public No!: number;

    /** 定型仕訳名称 */
    public Name!: string;

    /** 連想 */
    public RenChar!: string;

    public ColorChange!: number;
}

/**
 * KeyとValueを持つデータを示すインターフェース
 */
export interface KeyValueData {
    key: string;
    value: string;
}

/**
 * KeyとValueを持つデータを示すインターフェース
 */
export interface ComboKeyValueData {
    code: string;
    name: string;
}

/**
 * Key(number)とリストを持つデータを示すインターフェース
 */
export interface Dictionary<T> {
    [key: number]: T[];
}

/** linq制御の実装（Arrayの拡張） ここから */
// 利便性を考慮し名前空間(module)の中には入れない
// linq.jsはパフォーマンスに難ありの情報があり採用を見送ったが、あれば便利な機能もあるため必要なものだけ自作。
// ループ処理のラッパーとしてシンプルに実装すればパフォーマンスに影響はないはず。
declare global {
    interface Array<T> {
        select<T>(func: Function): Array<any>;
        where(func: (r: T) => boolean): Array<T>;
        any<T>(func: Function): boolean;
        singleOrNull(func: Function): T;
        positionOrNull(func: Function): number;
        min<T>(func: (e: any) => number): T;
        max<T>(func: (e: any) => number): T;
    }
}

Array.prototype.select = function (func) {
    var array = [];
    for (var i = 0; i < this.length; i++) {
        var value = func.call(this, this[i]);
        array.push(value);
    }
    return array;
}

Array.prototype.where = function (func) {
    var array = [];
    for (var i = 0; i < this.length; i++) {
        if (func.call(this, this[i])) {
            array.push(this[i]);
        }
    }
    return array;
}

Array.prototype.any = function (func) {
    for (var i = 0; i < this.length; i++) {
        if (func.call(this, this[i])) {
            return true;
        }
    }
    return false;
}

Array.prototype.singleOrNull = function (func) {
    for (var i = 0; i < this.length; i++) {
        if (func.call(this, this[i], i)) {
            return this[i];
        }
    }
    return null;
}

Array.prototype.positionOrNull = function (func) {
    for (var i = 0; i < this.length; i++) {
        if (func.call(this, this[i], i)) {
            return i;
        }
    }
    return null!;
}

Array.prototype.min = function (func) {
    var targets = this.select(func);
    var minValue = Math.min.apply(null, targets);
    var pos = targets.positionOrNull((e: any) => e == minValue);
    return pos === null ? null : this[pos];
}

Array.prototype.max = function (func) {
    var targets = this.select(func);
    var maxValue = Math.max.apply(null, targets);
    var pos = targets.positionOrNull((e: any) => e == maxValue);
    return pos === null ? null : this[pos];
}
/** linq制御の実装（Arrayの拡張） ここまで */


/** 各種拡張実装 ここから */
declare global {
    interface String {
        /**
         * 指定文字数となるように、指定文字を左側に付与する
         * @param totalLength: 最終的な文字数
         * @param padChar: 左側に付与する文字
         */
        padLeft(totalLength: number, padChar: string): string;
        /**
         * 文字列の右側にあるスペースを取り除く(前0ありコード等に使用する)
         * @param str
         */
        trimRight(): string;

        format(...args: any[]): string;
    }
}

String.prototype.padLeft = function (totalLength: number, padChar: string) {
    return Array(totalLength - this.length + 1).join(padChar) + this;
}

String.prototype.trimRight = function () {
    return this.replace(/\s+$/g, "");
}

/**
 * 文字列置き換え用のFormat関数を追加
 */
String.prototype.format = function (...args: any[]): string {
    // 置換ファンク
    var rep_fn = undefined;

    // オブジェクトの場合
    if (typeof args == "object") {
        rep_fn = function (m: any, k: string | number) { return args[k]; }
    }
    // 複数引数だった場合
    else {
        rep_fn = function (m: any, k: string) { return args[parseInt(k)]; }
    }

    return this.replace(/\{(\w+)\}/g, rep_fn);
}



declare global {
    interface Number {
        /**
         * 指定文字数となるように、指定文字を左側に付与する
         * @param totalLength: 最終的な文字数
         * @param padChar: 左側に付与する文字
         */
        padLeft(totalLength: number, padChar: string): string;
    }
}

declare global {
    interface NumberConstructor {
        /**
         * 引数として与えた数がNaNであり、且つNumber型かどうかの真偽値を返します。
         */
        isNaN(number: number): boolean;
    }
}

Number.prototype.padLeft = function (totalLength: number, padChar: string) {
    return Array(totalLength - String(this).length + 1).join(padChar) + this;
}

Number.isNaN = Number.isNaN || function (value: number) {
    return typeof value === "number" && value !== value;
}

declare global {
    interface Date {
        /**
         * インスタンスの複製を作成する
         */
        clone(): Date;
    }
}
Date.prototype.clone = function () {
    return new Date(this.getTime());
}
/** 各種拡張実装 ここまで */


/** Tupleクラス実装 ここから */
export class Tuple<T1, T2> {
    private _item1: T1;
    private _item2: T2;
    constructor(item1: T1, item2: T2) {
        this._item1 = item1;
        this._item2 = item2;
    }
    public get Item1(): T1 { return this._item1; }
    public get Item2(): T2 { return this._item2; }
}

export class Tuple3<T1, T2, T3> {
    private _item1: T1;
    private _item2: T2;
    private _item3: T3;
    constructor(item1: T1, item2: T2, item3: T3) {
        this._item1 = item1;
        this._item2 = item2;
        this._item3 = item3;
    }
    public get Item1(): T1 { return this._item1; }
    public get Item2(): T2 { return this._item2; }
    public get Item3(): T3 { return this._item3; }
}

export class Tuple4<T1, T2, T3, T4> {
    private _item1: T1;
    private _item2: T2;
    private _item3: T3;
    private _item4: T4;
    constructor(item1: T1, item2: T2, item3: T3, item4: T4) {
        this._item1 = item1;
        this._item2 = item2;
        this._item3 = item3;
        this._item4 = item4;
    }
    public get Item1(): T1 { return this._item1; }
    public get Item2(): T2 { return this._item2; }
    public get Item3(): T3 { return this._item3; }
    public get Item4(): T4 { return this._item4; }
}

export class Tuple5<T1, T2, T3, T4, T5> {
    private _item1: T1;
    private _item2: T2;
    private _item3: T3;
    private _item4: T4;
    private _item5: T5;
    constructor(item1: T1, item2: T2, item3: T3, item4: T4, item5: T5) {
        this._item1 = item1;
        this._item2 = item2;
        this._item3 = item3;
        this._item4 = item4;
        this._item5 = item5;
    }
    public get Item1(): T1 { return this._item1; }
    public get Item2(): T2 { return this._item2; }
    public get Item3(): T3 { return this._item3; }
    public get Item4(): T4 { return this._item4; }
    public get Item5(): T5 { return this._item5; }
}
/** Tupleクラス実装 ここまで */

export class MjsUtilities {

    /**
     * NULL判定を行なう
     * @param value
     * @return true: null,"", undefined false: それ以外
     */
    public static isNull(value: any): boolean {
        return (value == null || value == "" || value === undefined);
    }


    /**
     * トリムを行なう
     * トリムの対象は（\sと全角スペース）
     * @param value
     * @param isMultiSpace　true: 全角スペースも含める　false: 全角スペースは含めない
     */
    public static trim(value: string, isMultiSpace = false): string {
        if (this.isNull(value)) {
            return value;
        }
        else {
            if (isMultiSpace) {
                return value.replace(/(^(\s|　)+)|((\s|　)+$)/g, "");
            }
            else {
                return value.replace(/(^\s+)|(\s+$)/g, "");
            }
        }
    }

    /**
     * 左トリムを行なう
     * トリムの対象は（\sと全角スペース）
     * @param value
     * @param isMultiSpace　true: 全角スペースも含める　false: 全角スペースは含めない
     */
    public static ltrim(value: string, isMultiSpace = false): string {
        if (this.isNull(value)) {
            return value;
        }
        else {
            if (isMultiSpace) {
                return value.replace(/^(\s|　)+/, "");
            }
            else {
                return value.replace(/^\s+/, "");
            }
        }
    }

    /**
     * 右トリムを行なう
     * トリムの対象は（\sと全角スペース）
     * @param value
     * @param isMultiSpace　true: 全角スペースも含める　false: 全角スペースは含めない
     */
    public static rtrim(value: string, isMultiSpace = false): string {
        if (this.isNull(value)) {
            return value;
        }
        else {
            if (isMultiSpace) {
                return value.replace(/(\s|　)+$/, "");
            }
            else {
                return value.replace(/\s+$/, "");
            }
        }
    }

    /**
     * 値をコピーします。
     * 注) オブジェクトが参照渡しとなってしまうため、ネストしたクラスのコピーは下記DeepObjectCopyの方が望ましい。
     * @param destination
     * @param source
     */
    public static deepCopy(destination: any, source: any) {
        $.extend(true, destination, source);
    };

    /**
     * deepコピーではネストされたオブジェクトが参照渡しとなってしまっているため、
     * 必要があれば、こちらを使用してもらうことにする。
     * @param source
     */
    public static deepObjectCopy(source: any): any {
        return { ...source };
    };


    /**
     * 数値を金額表記文字列に変換する。ロケーションがjaならカンマ区切り。
     * @param amount
     */
    public static toAmountString(amount: number): string {
        return String(amount).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    }

    /**
     * 金額表記文字列を数値に変換する。ロケーションがjaならカンマが除去される。
     * @param amount
     */
    public static toNumberFromAmount(amount: string): number {
        return parseInt(amount.replace(/,/g, ""));
    }

    /**
     * モデルオブジェクトを再構築する。
     *  ※値に対する適切な整形（現時点では日付文字列の日付型変換）が行われる
     * @param modelData
     */
    public static rebuildModelData(modelData: any) {
        for (var field in modelData) {
            var value = modelData[field];
            if (value != null) {
                if (typeof (value) === "object") {
                    MjsUtilities.rebuildModelData(value); // 再帰
                } else {
                    // 日付形式で表現される文字列を日付型へ変換
                    {
                        let matchResult = /Date\(([^)]+)\)/.exec(value);
                        if (matchResult) {
                            let date = new Date(parseFloat(matchResult[1]));
                            modelData[field] = date;
                        }
                    }

                    {
                        let matchResult = /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})*/.exec(value);
                        if (matchResult) {
                            let date = new Date(parseInt(matchResult[1]), parseInt(matchResult[2]) - 1, parseInt(matchResult[3]), parseInt(matchResult[4]), parseInt(matchResult[5]), parseInt(matchResult[6]));
                            modelData[field] = date;
                        }
                    }
                }
            }
        }
    }

    /**
     * サーバー送信用にViewModelに変換処理を行なう
     * 引数と戻り値のインスタンスは別になります
     * １）日付型をサーバーが受け取れる文字列に変換する
     *
     * @param model
     */
    public static stringify(model: any): any {
        let _model = {};

        // deepCopyでは参照渡しとなってしまうため、deepObjectCopy()を使用する
        // また、データなしのGetを使用する際に空データとして""が来るので、この場合は
        // コピーを行わない。
        //MjsUtilities.deepCopy(model);
        if (model instanceof Object) {
            _model = MjsUtilities.deepObjectCopy(model);
        } else {
            MjsUtilities.deepCopy(_model, model);
        }

        for (var field in _model) {

            let value = _model[field];
            if (value != null) {
                if (value instanceof Date) {
                    _model[field] = MjsUtilities.dateStringify(value);
                } else {
                    if (typeof (value) === "object") {
                        MjsUtilities.deepCopy(_model[field], MjsUtilities.stringify(value)); // 再帰
                    }
                }
            }
        }

        return _model;
    }

    /**
     * 日付型に設定されたタイムゾーンの文字列(ISO8601形式)に変換する
     * yyyy-MM-ddThh:mm:ss.fffK
     * @param date
     */
    public static dateStringify(date: Date): string {
        let dateString: string;

        // タイムゾーンを文字列に情報として入れ込む必要がないので、削除した形で文字列を作成する
        //dateString = date.getFullYear().padLeft(4, "0") + "-" + (date.getMonth() + 1).padLeft(2, "0") + "-" + date.getDate().padLeft(2, "0") + "T" + date.getHours().padLeft(2, "0") + ":" + date.getMinutes().padLeft(2, "0") + ":" + date.getSeconds().padLeft(2, "0") + "." + date.getMilliseconds().padLeft(3, "0") + MjsUtilities.getTimeZoneSuffix(date);
        dateString =
            date.getFullYear().padLeft(4, "0") + "-" +// 年
            (date.getMonth() + 1).padLeft(2, "0") + "-" +// 月
            date.getDate().padLeft(2, "0") +// 日

            "T" +
            date.getHours().padLeft(2, "0") + ":" +// 時
            date.getMinutes().padLeft(2, "0") + ":" + // 分
            date.getSeconds().padLeft(2, "0") + // 分 //"." +
            //date.getMilliseconds().padLeft(3, "0") +
            //MjsUtilities.getTimeZoneSuffix(date);
            "";

        return dateString;
    }

    /**
     * 日付型に設定されているタイムゾーンの指定子を取得する
     * @param date
     */
    public static getTimeZoneSuffix(date: Date): string {
        let offset = date.getTimezoneOffset();
        if (offset === 0) {
            return "Z";
        }
        let offsetHour = Math.floor(Math.abs(offset) / 60);
        let offsetMinute = Math.abs(offset) - (60 * offsetHour);

        return ((offset > 0) ? "-" : "+") + offsetHour.padLeft(2, "0") + offsetMinute.padLeft(2, "0");
    }

    /**
     * SJIS換算の文字列バイト数を取得する
     * @param str
     */
    public static getSjisByteCount(str: string): number {
        var length = 0;
        for (var i = 0; i < str.length; i++) {
            var c = str.charCodeAt(i);
            // Shift_JIS: 0x0 ～ 0x80, 0xa0 , 0xa1 ～ 0xdf , 0xfd ～ 0xff 
            // Unicode : 0x0 ～ 0x80, 0xf8f0, 0xff61 ～ 0xff9f, 0xf8f1 ～ 0xf8f3 
            if ((c >= 0x0 && c < 0x81) || (c == 0xf8f0) || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4)) {
                length += 1;
            } else {
                length += 2;
            }
        }
        return length;
    }

    /**
     * SJIS換算の文字列バイト数分に切り出した文字列を取得する
     * @param str
     * @param sjisByteCount
     */
    public static cutString(str: string, sjisByteCount: number): string {
        var length = 0;
        var result = "";
        for (var i = 0; i < sjisByteCount; i++) {
            var c = str.charCodeAt(i);
            // Shift_JIS: 0x0 ～ 0x80, 0xa0 , 0xa1 ～ 0xdf , 0xfd ～ 0xff 
            // Unicode : 0x0 ～ 0x80, 0xf8f0, 0xff61 ～ 0xff9f, 0xf8f1 ～ 0xf8f3 
            if ((c >= 0x0 && c < 0x81) || (c == 0xf8f0) || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4)) {
                length += 1;
            } else {
                length += 2;
            }

            if (length <= sjisByteCount) {
                result = result + str[i];
            } else {
                break;
            }
        }
        return result;
    }

    /**
     * 構造化されたコンテキストメニューアイテムから、特定のアイテムを取得する。jqueryUIのJQueryContextMenuに対する拡張実装です。
     * @param parentItems: JQueryContextMenuOptions.itemsで表現される、コンテキストメニューの親アイテム配列
     * @param key: アイテムを特定するためのキー
     */
    public static findContextMenuItem(parentItems: { [x: string]: any; }, key: string): any {
        var result = null;
        var keys = Object.keys(parentItems);

        var targetKey = keys.singleOrNull((k: string) => k == key);
        if (targetKey != null) {
            return parentItems[targetKey];
        }

        $.each(keys, (idx: any, k: string | number) => {
            var item = parentItems[k];
            if (item.items) {
                var tmpResult = this.findContextMenuItem(item.items, key);
                if (tmpResult != null) {
                    result = tmpResult;
                    return;
                }
            }
        });

        return result;
    }

    /**
     * 0Fillを行うコード文字列(10桁等)から指定桁数の0Fill文字列を作成する
     * @param str : "0000000001"などの文字列作成対象文字列。数値型に変換可能な文字列のみ指定可能。
     * @param length : 桁数の指定
     * @return : "0000000001"で、4桁であれば、"0001"を返す。
     *           strに数値型に変換できない文字列が指定された場合はそのまま返す。
     */
    public static createZeroFillString(str: string, length: number): string {
        let val: number = parseInt(str);
        if (val == 0 || val) {
            return val.padLeft(length, "0");
        }
        return str;
    }

    /**
     * 独自エンコードされた摘要文字列をデコード
     * @param tekiyo
     */
    public static decodeTekiyo(tekiyo: string): string {
        if (tekiyo == null) return tekiyo;
        let result: string = tekiyo;
        result = result.replace(new RegExp(SummaryReplaceString.BalanceManagementSummary, "g"), "<span class='" + SummaryStyleClass.SummaryBalance + "'>");
        result = result.replace(new RegExp(SummaryReplaceString.ExeSummary, "g"), "<span class='" + SummaryStyleClass.SpeSummary + "'>");
        result = result.replace(new RegExp(SummaryReplaceString.FixSummary, "g"), "<span class='" + SummaryStyleClass.Classification2 + "'>");
        result = result.replace(new RegExp(SummaryReplaceString.SummaryEnd, "g"), "</span>");
        return result;
    }

    /**
     * 文字列を1文字単位に分割し、配列で返す。
     * JavaScriptのstring.split("")は一部のUnicode文字を正しく分割できないので要注意。
     * https://stackoverflow.com/questions/4547609/how-do-you-get-a-string-to-a-character-array-in-javascript#answer-34717402
     * @param str 分割したい文字列(nullを指定した場合、中身が0個の配列を返す)
     */
    public static splitString(str: string): string[] {
        if (MjsUtilities.isNull(str)) {
            return []; // 中身が0個の配列を返す。
        }
        // 文字列を1文字単位に分割し、配列で返す。
        // Chrome(Win)、Firefox(Win)、Edge(Win)、IE11(Win)、Chrome(Mac)で正しく動作する事を確認済み。
        return str.split(/(?=(?:[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))/);

        // 下記のパターンは全ブラウザで動くが一部のUnicode文字を2文字に分割してしまう。
        //   "分割したい文字列".split("")

        // 下記の4パターンはIE11(Win)で動作しない。
        //   for (let c of "分割したい文字列") console.log(c)
        //   [..."分割したい文字列"]
        //   Array.from("分割したい文字列")
        //   "分割したい文字列".split(/(?=[\s\S])/u)
    }

    /**
     * シフトJISではない文字を全て削除して返す。
     * @param str (シフトJISではない文字を削除したい)元の文字列
     */
    public static removeNotSjisChars(str: string): string {
        let tmp: string[] = MjsUtilities.splitString(str);
        for (let i: number = 0; i < tmp.length; i++) {
            if (EncodeUtil.canChangeSJIS(tmp[i]) == false) {
                tmp[i] = "";
            }
        }
        return tmp.join("");
    }
}

/**
 * 元号情報（和暦）インターフェース
 */
interface IEraInfo {
    warekiType: WarekiType;
    kanji: string;
    kanjiInitial: string;
    hiragana: string;
    hiraganaInitial: string;
    katakana: string;
    katakanaInitial: string;
    english: string;
    englishInitial: string;
    startDate: Date;
    endDate: Date;
    warekiStartYear: number;
    warekiEndYear: number;
}

/**
 * 元号情報（和暦）クラス
 */
export class EraInfo implements IEraInfo {
    /** 和暦種別 */
    public warekiType!: WarekiType;

    /** 元号(漢字) */
    public kanji!: string;

    /** 元号(漢字 頭文字) */
    public kanjiInitial!: string;

    /** 元号(ひらがな) */
    public hiragana!: string;

    /** 元号(ひらがな 頭文字) */
    public hiraganaInitial!: string;

    /** 元号(カタカナ) */
    public katakana!: string;

    /** 元号(カタカナ 頭文字) */
    public katakanaInitial!: string;

    /** 元号(英字) */
    public english!: string;

    /** 元号(英字 頭文字) */
    public englishInitial!: string;

    /** 開始日 */
    public startDate!: Date;

    /** 終了日 */
    public endDate!: Date;

    /** 開始年(和暦) */
    public warekiStartYear!: number;

    /** 終了年(和暦) */
    public warekiEndYear!: number;
}

/**
 * 和暦情報クラス
 */
export class WarekiInfo {

    /** 元号情報リスト */
    private static _EraInfoList: IEraInfo[] = [
        {
            warekiType: WarekiType.Meiji,
            kanji: "明治", kanjiInitial: "明",
            hiragana: "めいじ", hiraganaInitial: "め",
            katakana: "メイジ", katakanaInitial: "メ",
            english: "Meiji", englishInitial: "M",
            startDate: new Date(1868, (1 - 1), 1), endDate: new Date(1912, (7 - 1), 29), // 1868/01/01～1912/07/29
            warekiStartYear: 1, warekiEndYear: 45 // 明治1年～45年
        },
        {
            warekiType: WarekiType.Taisho,
            kanji: "大正", kanjiInitial: "大",
            hiragana: "たいしょう", hiraganaInitial: "た",
            katakana: "タイショウ", katakanaInitial: "タ",
            english: "Taisho", englishInitial: "T",
            startDate: new Date(1912, (7 - 1), 30), endDate: new Date(1926, (12 - 1), 24), // 1912/07/30～1926/12/24
            warekiStartYear: 1, warekiEndYear: 15 // 大正1年～15年
        },
        {
            warekiType: WarekiType.Showa,
            kanji: "昭和", kanjiInitial: "昭",
            hiragana: "しょうわ", hiraganaInitial: "し",
            katakana: "ショウワ", katakanaInitial: "シ",
            english: "Showa", englishInitial: "S",
            startDate: new Date(1926, (12 - 1), 25), endDate: new Date(1989, (1 - 1), 7), // 1926/12/25～1989/01/07
            warekiStartYear: 1, warekiEndYear: 64 // 昭和1年～64年
        },
        {
            warekiType: WarekiType.Heisei,
            kanji: "平成", kanjiInitial: "平",
            hiragana: "へいせい", hiraganaInitial: "へ",
            katakana: "ヘイセイ", katakanaInitial: "ヘ",
            english: "Heisei", englishInitial: "H",
            startDate: new Date(1989, (1 - 1), 8), endDate: new Date(2019, (4 - 1), 30), // 1989/01/08～2019/04/30
            warekiStartYear: 1, warekiEndYear: 31 // 平成1年～31年
        },
        {
            warekiType: WarekiType.Reiwa,
            kanji: "令和", kanjiInitial: "令",
            hiragana: "れいわ", hiraganaInitial: "れ",
            katakana: "レイワ", katakanaInitial: "レ",
            english: "Reiwa", englishInitial: "R",
            startDate: new Date(2019, (5 - 1), 1), endDate: new Date(2099, (12 - 1), 31), // 2019/05/01～2099/12/31
            warekiStartYear: 1, warekiEndYear: 81 // 1年～81年
        }
    ];

    /** 元号情報リスト */
    public static get EraInfoList(): IEraInfo[] { return WarekiInfo._EraInfoList; }

    /**
     * 和暦種別に応じた元号情報を取得する
     * @param warekiType 和暦種別
     */
    public static getEraInfo(warekiType: WarekiType): IEraInfo {
        return WarekiInfo.EraInfoList.singleOrNull((x: IEraInfo) => x.warekiType == warekiType);
    }

    /** 明治の元号情報を取得する */
    public static getMeijiInfo(): IEraInfo { return WarekiInfo.getEraInfo(WarekiType.Meiji); }
    /** 大正の元号情報を取得する */
    public static getTaishoInfo(): IEraInfo { return WarekiInfo.getEraInfo(WarekiType.Taisho); }
    /** 昭和の元号情報を取得する */
    public static getShowaInfo(): IEraInfo { return WarekiInfo.getEraInfo(WarekiType.Showa); }
    /** 平成の元号情報を取得する */
    public static getHeiseiInfo(): IEraInfo { return WarekiInfo.getEraInfo(WarekiType.Heisei); }
    /** 令和の元号情報を取得する */
    public static getReiwaInfo(): IEraInfo { return WarekiInfo.getEraInfo(WarekiType.Reiwa); }

    /**
     * システム日付の和暦情報を取得する
     */
    public static getTodayWarekiInfo(): WarekiInfo {
        return WarekiInfo.getWarekiInfo();
    }

    /**
     * 指定日付の和暦情報を取得する
     * 指定しない場合はシステム日付の和暦情報を取得する
     * @param date 指定日付
     */
    public static getWarekiInfo(date?: Date): WarekiInfo {
        if (date == null)
            date = new Date();

        // 日付に対応する元号情報を取得
        var eraInfo = WarekiInfo.getEraInfoFromDate(date);
        if (eraInfo == undefined) return undefined!;

        // 指定日付に対応する和暦情報を返す
        let warekiType: WarekiType = eraInfo.warekiType;
        let warekiYear: number = date.getFullYear() - eraInfo.startDate.getFullYear() + 1;

        return new WarekiInfo(warekiType, warekiYear);
    }

    /**
     * システム日付の元号情報を取得する
     * ※「平成」「昭和」など、元号それ自体の情報
     */
    public static getTodayEraInfo(): IEraInfo {
        return WarekiInfo.getEraInfoFromDate();
    }

    /**
     * 指定日付の元号情報を取得する
     * 指定しない場合はシステム日付の元号情報を取得する
     * ※「平成」「昭和」など、元号それ自体の情報
     * @param date 指定日付
     */
    public static getEraInfoFromDate(date?: Date): IEraInfo {
        if (date == null)
            date = new Date();

        let i: number;
        for (i = 0; i < WarekiInfo.EraInfoList.length; i++) {
            if (date < WarekiInfo.EraInfoList[i].startDate) {
                if (i == 0) return undefined!; // 明治以前
                break;
            }
        }
        // 指定日付に対応する元号情報を返す
        return WarekiInfo.EraInfoList[i - 1];
    }

    /**
     * 元号(英字)の頭文字かどうか
     * @param englishIni 英文字
     */
    public static isWarekiInitial(englishInitial: string): boolean {
        if (!englishInitial) return false;

        for (let i = 0; i < WarekiInfo.EraInfoList.length; i++) {
            if (WarekiInfo.EraInfoList[i].englishInitial == englishInitial.toUpperCase()) {
                return true;
            }
        }
        return false;
    }


    private mWarekiType!: WarekiType;
    private mWarekiYear!: number;
    private mEraInfo!: IEraInfo;

    /**
     * コンストラクター
     * @param warekiType
     * @param warekiYear
     */
    constructor(warekiType: WarekiType, warekiYear: number) {
        this.warekiType = warekiType;
        this.warekiYear = warekiYear;
    }

    /** 和暦種別 */
    public get warekiType(): WarekiType { return this.mWarekiType; }
    public set warekiType(value: WarekiType) {
        this.mWarekiType = value;
        // 和暦種別に対応する元号情報をセット
        this.mEraInfo = WarekiInfo.getEraInfo(value);
    }

    /** 和暦年 */
    public get warekiYear(): number { return this.mWarekiYear; }
    public set warekiYear(value: number) { this.mWarekiYear = value; }

    /** 元号情報を返す */
    public get eraInfo(): IEraInfo { return this.mEraInfo; }

    /** 和暦の漢字を返す（例："平成"） */
    public get warekiKanjiChar(): string { return this.mEraInfo.kanji; }

    /** 和暦の英文字を返す（例："H"） */
    public get warekiInitialChar(): string { return this.mEraInfo.englishInitial; }

    /** 西暦年を算出してそれを返す */
    public getSeirekiYear(): number {
        if (this.eraInfo == null) return null!;
        return (this.warekiYear + this.eraInfo.startDate.getFullYear() - 1);
    }
}

/**
 * 日付範囲を表現するクラス
 */
export class DateRange {
    private mInnerMonth: number;
    private mOuterMonth: number;
    private mFrom: Date;
    private mTo: Date;

    constructor(innerMonth: number, outerMonth: number, from: Date, to: Date) {
        this.mInnerMonth = innerMonth;
        this.mOuterMonth = outerMonth;
        this.mFrom = from;
        this.mTo = to;
    }

    /**
     * 内部月を取得する
     */
    public get innerMonth(): number {
        return this.mInnerMonth;
    }

    /**
     * 外部月を取得する
     */
    public get outerMonth(): number {
        return this.mOuterMonth;
    }

    /**
     * 範囲開始日を取得する
     */
    public get from(): Date {
        return this.mFrom;
    }

    /**
     * 範囲終了日を取得する
     */
    public get to(): Date {
        return this.mTo;
    }
}

/**
 * 日付関連のユーティリティクラス
 */
export class DateUtil {

    /**
     * 和暦種別、和暦年をもとに西暦年を取得する
     * @param warekiType
     * @param warekiYear
     */
    public static getSeireki(warekiType: WarekiType, warekiYear: number): number {
        return new WarekiInfo(warekiType, warekiYear).getSeirekiYear();
    }

    /**
     * 和暦情報をもとに西暦年を取得する
     * @param warekiInfo
     */
    public static getSeirekiByWarekiInfo(warekiInfo: WarekiInfo): number {
        return warekiInfo ? warekiInfo.getSeirekiYear() : null!;
    }

    /**
     * 西暦年もしくは西暦年月日(数値型)をもとに和暦情報を取得する
     * @param yearORymd yyyy[MM[dd]](例：2019, 201901, 20190102)
     */
    public static getWareki(yearORymd: number): WarekiInfo {
        if (!yearORymd || yearORymd <= 0) return null!;

        // ymdを求める
        let year: number = 0;
        let month: number = 0;
        let day: number = 0;
        let yORymdStr: string = String(yearORymd);
        switch (yORymdStr.length) {
            case 1: case 2: case 3: case 4:
                // 引数は年
                year = yearORymd;
                break;
            case 5: case 6: //case 5:"20191" → 2019年1月扱い
                // 引数は年月
                year = parseInt(yORymdStr.slice(0, 4));
                month = parseInt(yORymdStr.slice(4));
                break;
            case 7: case 8: //case 7:"2019012" → 2019年1月2日扱い
                // 引数は年月日
                year = parseInt(yORymdStr.slice(0, 4));
                month = parseInt(yORymdStr.slice(4, 6));
                day = parseInt(yORymdStr.slice(6));
                break;
            default:
                // 8桁超過は不正扱い
                return null!;
        }

        // 引数が年のみだった場合
        if (month == 0 && day == 0) {
            // 年末時点の和暦情報を返す
            let endOfTheYear: Date = new Date(year + 1, 1 - 1, 0);
            return DateUtil.getWarekiinfo(endOfTheYear);
        }

        // 引数が年月のみだった場合
        if (day == 0 && DateUtil.isDate(year, month, 1)) {
            // 月末時点の和暦情報を返す
            let lastDayOfTheMonth: Date = new Date(year, month, 0);
            return DateUtil.getWarekiinfo(lastDayOfTheMonth);
        }

        // 和暦情報を返す
        return DateUtil.getWarekiInfo(year, month, day);
    }

    /**
     * 西暦年月日をもとに和暦情報を取得する
     * @param date 西暦年月日
     */
    public static getWarekiinfo(date: Date): WarekiInfo {
        return WarekiInfo.getWarekiInfo(date);
    }

    /**
     * 西暦年月日をもとに和暦情報を取得する
     * @param seirekiYear 西暦年
     * @param month 月
     * @param day 日
     */
    public static getWarekiInfo(seirekiYear: number, month: number, day: number): WarekiInfo {
        if (!DateUtil.isDate(seirekiYear, month, day)) return undefined!;

        let date: Date = new Date(seirekiYear, month - 1, day);
        return WarekiInfo.getWarekiInfo(date);
    }

    /**
     * 日付の妥当性を判定する
     * @param year 年(西暦)
     * @param month 月(1～12)
     * @param day 日(1～31)
     */
    public static isDate(year: number, month: number, day: number): boolean {
        var lastDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        if ((month < 1) || (month > 12) || (day < 1)) {
            return false;
        }

        if (month == 2 && ((year % 4) == 0 && (year % 100) != 0) || (year % 400) == 0) {
            lastDays[1] = 29;
        }

        if (day > lastDays[month - 1]) {
            return false;
        }

        return true;
    }

    public static toDate(value: string): Date {
        return new Date(value);
    }

    public static format(value: string, format: string) {
        var date = this.toDate(value);

        if (!format) {
            format = 'YYYY-MM-DD hh:mm:ss.SSS';
        }

        let wareki: WarekiInfo = DateUtil.getWarekiinfo(date);

        format = format.replace(/YYYY/g, date.getFullYear().toString());

        format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
        format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2));
        format = format.replace(/hh/g, ('0' + date.getHours()).slice(-2));
        format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
        format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
        if (format.match(/S/g)) {
            var milliSeconds = ('00' + date.getMilliseconds()).slice(-3);
            var match = format.match(/S/g)
            var length = match ? match.length : 0;
            for (var i = 0; i < length; i++) format = format.replace(/S/, milliSeconds.substring(i, i + 1));
        }

        // 和暦対応
        // -----------------------------------
        //  デフォルトフォーマットのミリセカンド部が、"S(大文字のS)"で表現されているため、
        // ミリセカンドの処理よりも前に和暦処理を入れてしまうと、昭和の「S」が置き換えられて
        // しまう。そのため、最後に和暦の対応を行う必要がある。
        // -----------------------------------
        if(wareki){
            format = format.replace(/GG/g, wareki.warekiKanjiChar);
            format = format.replace(/G/g, wareki.warekiInitialChar);
            format = format.replace(/YY/g, ('0' + wareki.warekiYear).slice(-2));
        }

        return format;
    }

    public static formatYMDtoNumber(date: Date): number {
        let dateString = DateUtil.format(date.toString(), "YYYYMMDD");
        let dateNumber = parseInt(dateString);

        return dateNumber;
    }

    public static formatYMtoNumber(date: Date): number {
        let dateString = DateUtil.format(date.toString(), "YYYYMM00");
        let dateNumber = parseInt(dateString);

        return dateNumber;
    }

    /**
     * 年月日の各値を丸めた日付オブジェクトを取得する
     * 凡例：0月→1月、 13月→12月 ／ 0日→1日、 32日→月末日(28～31日)
     * 実例：2019/02/99 → 2019/02/28、 2019/00/12→ 2019/01/12
     * @param seirekiYear 年(西暦)
     * @param month 月
     * @param day 日
     */
    public static getRoundDate(seirekiYear: number, month: number, day: number): Date {
        // 引数未設定の場合はシステム日付の年月日を使用する
        let today: Date = new Date();
        if (seirekiYear == undefined) seirekiYear = today.getFullYear();
        if (month == undefined) month = today.getMonth() + 1;
        if (day == undefined) day = today.getDate();

        //  年をシステム日付の年に補正
        if (!this.isDate(seirekiYear, 1, 1)) seirekiYear = today.getFullYear();
        //  月を1～12に補正
        if (!this.isDate(seirekiYear, month, 1)) month = Math.min(Math.max(month, 1), 12);
        //  日を1～月末日に補正
        if (!this.isDate(seirekiYear, month, day)) {
            let lastDateOfMonth = new Date(seirekiYear, month, 0).getDate(); // 月末日
            day = Math.min(Math.max(day, 1), lastDateOfMonth);
        }

        let roundDate: Date = new Date(seirekiYear, month - 1, day);
        return roundDate;
    }
}

//Mjs.Acelink.VKZ\Areas\OfficeAdmin\Scripts\mjs\common\usefuls\adminUtilitiesのAdminEncodeUtilは当処理の内容をコピーしているため修正の際はそちらも修正すること
export class EncodeUtil {
    // 処理の参考：http://aok.blue.coocan.jp/jscript/jcode.html
    // 

    //private static jis_table: string = "　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈〉《》「」『』【】＋－±×÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓???????????∈∋⊆⊇⊂⊃∪∩????????∧∨￢⇒⇔∀∃???????????∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬???????Å‰♯♭♪†‡¶????◯???????????????０１２３４５６７８９???????ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ??????ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ????ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん???????????ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ????????ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ????????αβγδεζηθικλμνξοπρστυφχψω??????????????????????????????????????АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ???????????????абвгдеёжзийклмнопрстуфхцчшщъыьэюя?????????????─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂??????????????????????????????????????????????????????????????①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ?㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡????????㍻〝〟№㏍℡㊤㊥㊦㊧㊨㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪??亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕???????????????????????????????????????????弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙";
    private static jis_table: string = "　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈〉《》「」『』【】＋－±×÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓???????????∈∋⊆⊇⊂⊃∪∩????????∧∨￢⇒⇔∀∃???????????∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬???????Å‰♯♭♪†‡¶????◯???????????????０１２３４５６７８９???????ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ??????ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ????ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん???????????ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ????????ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ????????αβγδεζηθικλμνξοπρστυφχψω??????????????????????????????????????АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ???????????????абвгдеёжзийклмнопрстуфхцчшщъыьэюя?????????????─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂??????????????????????????????????????????????????????????????①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ?㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡????????㍻〝〟№㏍℡㊤㊥㊦㊧㊨㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪??亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕???????????????????????????????????????????弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙￤＇＂纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑";

    private static uc_table: any[];

    private static initTable() {
        this.uc_table = new Array(0xffff);
        for (var i = 0; i < EncodeUtil.jis_table.length; i++) {
            var ch = ~~(i / 0x5e);
            var cl = (i % 0x5e) + 0x21;
            if (ch >= 0 && ch < 8)
                ch += 0x21;
            else if (ch >= 8 && ch < 9)
                ch += 0x2d - 8;
            else
                ch += 0x30 - 9;
            if (EncodeUtil.uc_table) {
                EncodeUtil.uc_table[EncodeUtil.jis_table.charCodeAt(i)] = (ch << 8) | cl;
            }
        }
    }

    public static canChangeSJIS(str: string) {
        if (EncodeUtil.uc_table == null) {
            EncodeUtil.initTable();
        }
        var sjis = EncodeUtil._to_sjis(str);
        var utf8 = EncodeUtil._from_sjis(sjis);

        if (str != utf8) {
            return false;
        } else {
            return true;
        }
    }

    private static _sjis_to_jis(k1: number, k2: number) {
        k1 = (k1 << 1) & 0xff;
        if (k2 < 0x9f) {
            if (k1 < 0x3f) k1 += 0x1f; else k1 -= 0x61;
            if (k2 > 0x7e) k2 -= 0x20; else k2 -= 0x1f;
        } else {
            if (k1 < 0x3f) k1 += 0x20; else k1 -= 0x60;
            k2 -= 0x7e;
        }
        return (k1 << 8) | k2;
    }

    private static _jis_to_sjis(k1: number, k2: number) {
        if (k1 & 0x01) {
            k1 >>= 1;
            if (k1 < 0x2f) k1 += 0x71; else k1 -= 0x4f;
            if (k2 > 0x5f) k2 += 0x20; else k2 += 0x1f;
        } else {
            k1 >>= 1;
            if (k1 <= 0x2f) k1 += 0x70; else k1 -= 0x50;
            k2 += 0x7e;
        }
        return ((k1 & 0xff) << 8) | k2;
    }

    private static _get_char_from_table(ch: number, cl: number) {
        var n = -1;
        if (ch >= 0x21 && ch <= 0x28)
            n = (ch - 0x21) * 0x5e + (cl - 0x21);
        else if (ch == 0x2d)
            n = (ch - 0x2d + 8) * 0x5e + (cl - 0x21);
        else if (ch >= 0x30 && ch <= 0x74)
            n = (ch - 0x30 + 9) * 0x5e + (cl - 0x21);
        //対応文字追加に伴い、chの許容範囲を拡大
        else if (ch >= 0x75 && ch <= 0x77)
            n = (ch - 0x30 + 9) * 0x5e + (cl - 0x21);
        if (n == -1 || n >= EncodeUtil.jis_table.length)
            return "?";
        return EncodeUtil.jis_table.charAt(n);
    }

    private static _get_code_from_table(c: string) {
        if (EncodeUtil.uc_table) {
            var p = EncodeUtil.uc_table[c.charCodeAt(0)];
            return (p ? p : -1);
        }
    }

    private static _from_sjis(s: string) {
        var c, ch = 0, r = "", p;
        for (var i = 0; i < s.length; i++) {
            c = s.charCodeAt(i);
            if (ch == 0) {
                if ((c >= 0x81 && c <= 0x9f) || (c >= 0xe0 && c <= 0xfc))
                    ch = c;
                else if (c >= 0xa1 && c <= 0xdf)
                    r += String.fromCharCode(65377 + (c - 0xa1));
                else
                    r += s.charAt(i);
            } else {
                if ((c >= 0x40 && c <= 0x7e) || (c >= 0x80 && c <= 0xfc)) {
                    p = EncodeUtil._sjis_to_jis(ch, c);
                    r += EncodeUtil._get_char_from_table(p >> 8, p & 0xff);
                } else {
                    r += "?";
                }
                ch = 0;
            }
        }
        return r;
    }

    private static _to_sjis(s: string) {
        var r = "", c, p, n;
        for (var i = 0; i < s.length; i++) {
            c = s.charCodeAt(i);
            if (c <= 127)
                r += s.charAt(i);
            else if (c >= 65377 && c <= 65439)
                r += String.fromCharCode(c - 65377 + 0xa1);
            else {
                p = EncodeUtil._get_code_from_table(s.charAt(i));
                if (p == -1) {
                    r += "?";
                } else {
                    n = EncodeUtil._jis_to_sjis(p >> 8, p & 0xff);
                    r += String.fromCharCode(n >> 8);
                    r += String.fromCharCode(n & 0xff);
                }
            }
        }
        return r;
    }
}

/**
 * クリップボード ユーティリティ
 */
export class ClipboardUtil {
    /**
     * クリップボードの値をStringで設定する
     * @param e
     * @param clipboardValue
     */
    public static setValueByString(e: ClipboardEvent, clipboardValue: string) {
        let winClb = (<any>window).clipboardData;
        if (winClb)
            winClb.setData("Text", clipboardValue); //IE
        else if (e.clipboardData)
            e.clipboardData.setData("text/plain", clipboardValue); //IE以外
    }

    /**
     * クリップボードの値をStringで取得する
     * @param e
     */
    public static getValueByString(e: ClipboardEvent): string {
        let clb = e.clipboardData || (<any>window).clipboardData;
        return clb ? clb.getData("Text") : "";
    }
}

export class TypedCollectionView<T> extends wijmo.CollectionView {

    constructor(sourceCollection: Array<T>) {
        super(sourceCollection);
    }

    public get typedItems(): T[] {
        return this.items;
    }
}

/**
 * ドリルダウン時リンク先を別ウィンドウで開くクラス
 */
export class DrillDownUtil {

    /**
     * ドリルダウンモードの振替伝票画面を別ウィンドウで開く
     * @param clientYear 会計年度
     * @param nMonth 仕訳内部月
     * @param hSrchNo 仕訳ヘッダ検索NO
     * @param drillDownKbn ドリルダウン区分
     */
    /* todo: 下記を実装
    public static EntryVoucherDrillDown(clientYear: number, nMonth: number, hSrchNo: number, drillDownKbn: number)　: void {
        let param: any = {
            clientYear: clientYear,
            nMonth: nMonth,
            hSrchNo: hSrchNo,
            drillDownKbn: drillDownKbn
        }

        var windowOption = new mjs.acelink.vkz.support.component.drillDown.WindowOption();

        mjs.acelink.vkz.support.component.drillDown.WindowUtil.postOpen(
            "/EntryVoucher/DrillDown"
            , param
            , windowOption
        );

    }
    */

    /**
     * ドリルダウンモードの入金伝票画面を別ウィンドウで開く
     * @param clientYear 会計年度
     * @param nMonth 仕訳内部月
     * @param hSrchNo 仕訳ヘッダ検索NO
     * @param drillDownKbn ドリルダウン区分
     */
    public static EntryCashInVoucherDrillDown(clientYear: number, nMonth: number, hSrchNo: number, drillDownKbn: number)　: void {
        let param: any = {
            clientYear: clientYear,
            nMonth: nMonth,
            hSrchNo: hSrchNo,
            drillDownKbn: drillDownKbn
        }

        var windowOption = new WindowOption();

        WindowUtil.postOpen(
            "/EntryCashInVoucher/DrillDown"
            , param
            , windowOption
        );

    }

    /**
     * ドリルダウンモードの出金伝票画面を別ウィンドウで開く
     * @param clientYear 会計年度
     * @param nMonth 仕訳内部月
     * @param hSrchNo 仕訳ヘッダ検索NO
     * @param drillDownKbn ドリルダウン区分
     */
    public static EntryCashOutVoucherDrillDown(clientYear: number, nMonth: number, hSrchNo: number, drillDownKbn: number)　: void {
        let param: any = {
            clientYear: clientYear,
            nMonth: nMonth,
            hSrchNo: hSrchNo,
            drillDownKbn: drillDownKbn
        }

        var windowOption = new WindowOption();

        WindowUtil.postOpen(
            "/EntryCashOutVoucher/DrillDown"
            , param
            , windowOption
        );
    }

    /**
     * ドリルダウンモードの各種マスタ登録画面を別ウィンドウで開く
     * (科目別補助、銀行、取引先・得意先・仕入先、社員、汎用補助1～5、部門、セグメント1～2、工事画面)
     * @param masterKbn マスタ区分
     * @param paramData 新しい画面を開くためのパラメータ
     */
    public static ExecMasterEntryDrillDown(masterKbn: number, paramData: any) {

        let getMasterDispName = function (masterKbn: number): any {
            //2:科目別補助 21:銀行 22:取引先  23:得意先 24:仕入先 25:社員 31:汎用補助1 32:汎用補助2 33:汎用補助3 34:汎用補助4 35:汎用補助5 41:部門 42:ｾｸﾞﾒﾝﾄ 51:工事
            let url: any = {};
            url[MasterKbn.EachKmkAuxiliary] = MasterDispName.CountingKmk;
            url[MasterKbn.Bank] = MasterDispName.Bank;
            url[MasterKbn.Client] = MasterDispName.Client;
            url[MasterKbn.Customers] = MasterDispName.Client;
            url[MasterKbn.Supplier] = MasterDispName.Client;
            url[MasterKbn.Staff] = MasterDispName.Staff;
            url[MasterKbn.GeneralPurposeAuxiliary1] = MasterDispName.GeneralPurposeAuxiliary;
            url[MasterKbn.GeneralPurposeAuxiliary2] = MasterDispName.GeneralPurposeAuxiliary;
            url[MasterKbn.GeneralPurposeAuxiliary3] = MasterDispName.GeneralPurposeAuxiliary;
            url[MasterKbn.GeneralPurposeAuxiliary4] = MasterDispName.GeneralPurposeAuxiliary;
            url[MasterKbn.GeneralPurposeAuxiliary5] = MasterDispName.GeneralPurposeAuxiliary;
            url[MasterKbn.Bmn] = MasterDispName.Bmn;
            url[MasterKbn.Segment1] = MasterDispName.Segment1;
            url[MasterKbn.Segment2] = MasterDispName.Segment1;
            url[MasterKbn.Koji] = MasterDispName.Koji;
            return url[masterKbn];
        };

        // ウィンドウオプションを設定
        var windowOption = new WindowOption();

        let url: any = "/" + getMasterDispName(masterKbn);

        // ドリルダウン
        WindowUtil.postOpen(
            url + "/DrillDown"
            , paramData
            , windowOption
        );
    }

    /**
     * ドリルダウンモードの固定摘要登録画面を別ウィンドウで開く
     */
    public static TekiyoEntoryDrillDown(param: any): void {
        var windowOption = new WindowOption();

        WindowUtil.postOpen(
            "/RegisterFixedMemorandum/DrillDown"
            , param
            , windowOption
        );
    }

    /**
     * ドリルダウンモードの仕訳辞書キーワード編集画面を別ウィンドウで開く
     */
    public static JournalDictionryDrillDown()　: void {
        var windowOption = new WindowOption();

        WindowUtil.postOpen(
            "/EntryJournalDictionary/DrillDown"
            , null!
            , windowOption
        );
    }

    /**
     * 指定されたURLでウィンドウを開く
     * @param sURL 新たに開くURL
     */
    public static windowOpen(sURL: string) {
        window.open(sURL);
    }
}
